import React, { useEffect, useRef } from "react";
import Button from "../../components/common/ui/Button";
// import Table from "../../components/common/table/Table";
import { useState } from "react";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import translate from "translate";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../components/common/ui/Loader";
import {
  inmateAction,
  messagesAction,
  publicUserActions,
  authActions,
} from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { StoredProcedures } from "../../_helpers/enumerator";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import PrintExport from "../../components/common/ui/Export/PrintExport";
import generateMessageConversationPDF from "../../components/common/export/Reports/generateMessageConversation";
import MessageViewer from "./MessageViewer";
import { useReactToPrint } from "react-to-print";
import translateText from "../../_helpers/GoogleTranslator";
import { getStoredValue } from "../../_helpers/storagehelper";

translate.engine = "google";
translate.key = undefined;

function PhotoInformation() {
  const location = useLocation();
  const dispatch = useDispatch();

  const locationMessageID = location?.state?.messageID
    ? location?.state?.messageID
    : 0;
  const selectedRowIndex = location?.state?.index ? location?.state?.index : 0;
  const messageDetails = location?.state?.messageDetails || [];
  const [totalRowCount, setTotalRowCount] = useState(0);

  const {
    messagesList,
    messagesIDSList,
    messageConversationDetails,
    submitReview,
    viewCompleteConversation,
    handleApproveRejectResponse,
    loading,
    messageSearchData
  } = useSelector((x) => x?.messages);
  const {
    PUMessageDataList,
    intialMessageSearch
  } = useSelector((x) => x.inmate);
  const { PUMessageDataIDSList } = useSelector((x) => x?.inmate);
  const { puInitialMessageSearch, loadMessageList } = useSelector((x) => x?.publicUser);
  const { source, Inmate, row } = location.state || {};
  const messageSearchDetails = source == "InmateMessage" ? intialMessageSearch : source === "publicUserMessage" ? puInitialMessageSearch : messageSearchData;
  const msgDataList = source == "InmateMessage" ? PUMessageDataList : source === "publicUserMessage" ? loadMessageList : messagesList;
  const facilityID = getStoredValue("commonFacilityCode");
  const prevFacilityCodeRef = useRef(facilityID);
  const [messageitem, setmessageitem] = useState();
  const [isloading, setisloading] = useState(false);
  const { user } = useSelector((x) => x.auth);
  //const { translatedMessages, translateMessages } = useTranslate();
  const [isTranslating, setIsTranslating] = useState(false);
  const [disbaleNoteBox, setDisbaleNoteBox] = useState(true);
  const [verifyNotes, setVerifyNotes] = useState(false);
  const isNotesRef = useRef(false);
  const [command, setCommand] = useState([]);
  const [showCompleteConvo, setShowCompleteConvo] = useState(false);
  const [messageID, setmessageID] = useState(locationMessageID ? locationMessageID : 0);
  const [indexValue, setIndexValue] = useState(selectedRowIndex);
  const [updateMessageContent, setUpdateMessageContent] = useState([]);
  const [updateSubjectContent, setUpdateSubjectContent] = useState([]);
  const [messageIndex, setmessageIndex] = useState(0);
  const [data, setData] = useState([]);
  const [selectLang, setselectLang] = useState("");
  const componentRef = useRef();
  const [isprevdisabled, setIsPrevDisabled] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(false);


  function addSpaceBetweenEmojisAndText(message) {
    const emojiWithTextRegex = /([\p{Extended_Pictographic}]+)(?=\w)/gu;
    const textBeforeEmojiRegex = /(\w)([\p{Extended_Pictographic}]+)/gu;

    if (Array.isArray(message)) {
      return message.map((msg) => {
        return msg
          .replace(textBeforeEmojiRegex, "$1 $2")
          .replace(emojiWithTextRegex, "$1 ");
      });
    } else {
      return message
        .replace(textBeforeEmojiRegex, "$1 $2")
        .replace(emojiWithTextRegex, "$1 ");
    }
  }

  const handlemessageDetails = (result, messageId) => {
    const content = [];
    const subject = [];
    setUpdateMessageContent(content);
    setUpdateSubjectContent(subject);
    const rowData = result;
    setTotalRowCount(result?.length || 0);
    const findIndex = result?.findIndex(
      (message) => message.MessageID === messageId
    );
    setmessageIndex(findIndex > 0 ? findIndex + 1 : 1);
    const messageContents = addSpaceBetweenEmojisAndText(
      rowData[0]?.MessageBody || ""
    );
    const MessageSubject = rowData[0]?.MessageSubject || "";
    const MessageReviewCommand = rowData[0]?.MessageReviewCommand || "";
    const commandTxt = [...command];
    commandTxt[0] = MessageReviewCommand;
    setCommand(commandTxt);
    const quarantineKeywords =
      rowData[0]?.MessageQuarantineKeyWords?.split("|").map((word) =>
        word.toLowerCase()
      ) || [];

    // Use regex to wrap matching words in a <span> tag with red color
    const regex = new RegExp(
      `\\b(${quarantineKeywords.join("|")})\\b`,
      "gi"
    );

    const highlightedMessageContent = messageContents.replace(
      regex,
      (match) => {
        return `<span style="color: red; font-weight: bold;">${match}</span>`;
      }
    );

    const highlightedSubject = MessageSubject.replace(regex, (match) => {
      return `<span style="color: red; font-weight: bold;">${match}</span>`;
    });
    content?.push(highlightedMessageContent);
    subject?.push(highlightedSubject);
    setUpdateMessageContent(content);
    setUpdateSubjectContent(subject);

  }

  useEffect(() => {
    if (showCompleteConvo) return;
    if (
      Object?.keys(msgDataList)?.length > 0
      //&& source !== "InmateMessage" &&
      // source !== "publicUserMessage"
    ) {
      // const messageId = indexValue > 0 ? msgDataList?.DataList?.[indexValue]?.MessageID : locationMessageID;
      const messageId = indexValue != -1 ? msgDataList?.DataList?.[indexValue]?.MessageID : locationMessageID;

      // if (indexValue > 0) {
      setmessageID(messageId);
      // }
      // if (messageDetails?.length > 0 && locationMessageID == messageId) {
      //   handlemessageDetails(messageDetails, messageId);
      // }
      //  else {
      const params = {
        messageID: messageId,
        sortBy: "MessageID DESC",
        pageNo: 1,
        rowCountPerPage: 10000,
      };
      dispatch(messagesAction?.getMessageConversationDetails(params))
        .then((result) => {
          handlemessageDetails(result?.payload?.DataList, messageId);
        })
        .catch((err) => { });
      //}
    }
    // else {
    //   setmessageID(locationMessageID);
    //   const params = {
    //     messageID: locationMessageID,
    //     sortBy: "MessageID Desc",
    //     pageNo: 1,
    //     rowCountPerPage: 1000,
    //   };
    //   dispatch(messagesAction?.getMessageConversationDetails(params));
    //   setmessageIndex(1);
    // }

    if (Object?.keys(msgDataList)?.length === 0 && source === "messageList")
      history?.navigate("MessageList");
  }, [indexValue, location]);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityID) {
      handleBack();
    }
  }, [facilityID]);

  useEffect(() => {
    if (
      Object?.keys(submitReview).length !== 0 &&
      submitReview?.IsSucceed === 1
    ) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: user?.FacilityID,
          ProcedureName: StoredProcedures?.InmateMessageReviewSave,
          UserAction: `Message Reviewed( Message ID - ${messageID} )`,
        })
      );
      showToastNotification("Review added successfully", "success");
    }
    if (
      Object?.keys(submitReview).length !== 0 &&
      submitReview?.IsSucceed !== 1
    ) {
      showToastNotification("Failed in Review", "error");
    }
  }, [submitReview]);

  useEffect(() => {
    switch (handleApproveRejectResponse?.ID) {
      case 1:
        showToastNotification("Quarantine approved successfully", "success");
        break;

      case 2:
        showToastNotification("Quarantine rejected successfully", "success");
        break;

      case -2:
        showToastNotification(
          "Quarantine message already approved or rejected",
          "info"
        );
        break;

      case -3:
        showToastNotification("Message not quarantine block.", "error");
        break;

      case -1:
        showToastNotification("Insert Failed.", "error");
        break;

      default:
        break;
    }
  }, [handleApproveRejectResponse]);

  const handleTranslate = async (language) => {
    isNotesRef.current = false;
    setselectLang(language);

    // Extract message bodies and subjects based on the current conversation view
    // const messageBodies = showCompleteConvo
    //   ? viewCompleteConversation.map((msg) => msg.MessageBody)
    //   : messageConversationDetails?.DataList.map((msg) => msg.MessageBody);

    // const subjectDetails = showCompleteConvo
    //   ? viewCompleteConversation.map((msg) => msg.MessageSubject)
    //   : messageConversationDetails?.DataList.map((msg) => msg.MessageSubject);

    // Translate the messages using Google Translate
    // const translated = await translateText(
    //   addSpaceBetweenEmojisAndText(messageBodies),
    //   language
    // );
    // const translatedSubject = await translateText(
    //   addSpaceBetweenEmojisAndText(subjectDetails),
    //   language
    // );

    // // Wrap the translated messages and subjects in <span> for styling
    // const updatedElement = translated?.map((text) => {
    //   return `<span>${text}</span>`;
    // });

    // const highlightedSubject = translatedSubject?.map((text) => {
    //   return `<span style="color: red; font-weight: bold;">${text}</span>`;
    // });

    // // Update the state with translated and styled content
    // setUpdateMessageContent(updatedElement);
    // setUpdateSubjectContent(highlightedSubject);
  };

  const handleReset = () => {
    if (showCompleteConvo) {
      const updateArr = viewCompleteConversation?.map((item, index) => {
        // if (item?.MessageID === data[0]?.MessageID) {
        return {
          ...item,
          isVerifyCheckbox:
            item?.MessageReviewCommand?.trim()?.length > 0 ? true : false,
        };
        // }
        // return item;
      });

      dispatch(messagesAction?.updateCompleteConvo(updateArr));
    } else {
      const tableData = [...messageConversationDetails?.DataList];
      const updateArr = tableData?.map((item, index) => {
        if (item?.MessageID === data[0]?.MessageID) {
          const returnvalue = {
            ...item,
            isVerifyCheckbox:
              item?.MessageReviewCommand?.trim()?.length > 0 ? true : false,
          };
          setData([returnvalue]);
          return returnvalue;
        }
        return item;
      });
    }
    setDisbaleNoteBox(true);
    setCommand([]);

    // const updateitem = data?.map((item) => ({
    //   ...item,
    //   isVerifyCheckbox:
    //     item?.MessageReviewCommand?.trim()?.length > 0 ? true : false,
    // }));

    handleTranslate("");
    //setData(updateitem);
  };

  const handleVerifyNotes = (e, i, MessageID) => {
    const { checked } = e?.target;
    isNotesRef.current = false;
    if (showCompleteConvo) {
      const updateArr = viewCompleteConversation?.map((item, index) => {
        if (item?.MessageID === MessageID) {
          return { ...item, isVerifyCheckbox: checked };
        }
        return item;
      });
      dispatch(messagesAction?.updateCompleteConvo(updateArr));
    } else {
      const tableData = [...messageConversationDetails?.DataList];
      const updateArr = tableData?.map((item, index) => {
        if (item?.MessageID === data[0]?.MessageID) {
          const returnvalue = { ...item, isVerifyCheckbox: checked };
          setData([returnvalue]);
          return returnvalue;
        }
        return item;
      });
      const res = {
        DataList: updateArr,
        TotalRecordCount: messageConversationDetails?.TotalRecordCount,
      };

      // dispatch(messagesAction?.updateMessageConversationDetails(res));
    }
    setVerifyNotes(checked);
    setDisbaleNoteBox(!checked);
  };

  const handleNotesChange = (e, index) => {
    isNotesRef.current = true;
    const { value } = e?.target;
    const commandTxt = [...command];
    commandTxt[index] = value;
    setCommand(commandTxt);
  };

  const handleReviewNotes = (id, index) => {
    if (messageID === 0 || command === "") return;
    const data = {
      messageID: id,
      command: command[index],
      userID: user?.ManagementUserID,
    };

    dispatch(messagesAction?.submitReview(data))
      .then((result) => {
        dispatch(messagesAction?.resetReviewResponse());
        //if (!showCompleteConvo) {
        const messagegridData = !showCompleteConvo ? data : viewCompleteConversation;
        const params = {
          messageID: messagegridData?.length > 0 ? messagegridData[0]?.MessageID : messageID,
          sortBy: "MessageID DESC",
          pageNo: 1,
          rowCountPerPage: 10000,
        };
        dispatch(messagesAction?.getMessageConversationDetails(params));
        // } else {
        //   dispatch(messagesAction?.viewCompleteConversation(messageID));
        // }
      })
      .catch((err) => {
        showToastNotification("Failed to submit review", "error");
      });
  };

  const handleApproveOrRejectconfirm = (id, e, option, item) => {
    const payload = {
      messageID: id,
      facilityID: facilityID,
      messageQuarantineApprove: option === "approve" ? 1 : 0,
      messageQuarantineReject: option === "reject" ? 1 : 0,
      createdBy: 0,
      taskGUID: "",
      inmateID: item?.InmateID,
    };
    dispatch(messagesAction?.handleApproveReject(payload))
      .then((result) => {
        dispatch(messagesAction?.resetApproveRejectResponse());
        // if (!showCompleteConvo) {
        const messagegridData = !showCompleteConvo ? data : viewCompleteConversation;
        const params = {
          messageID: messagegridData?.length > 0 ? messagegridData[0]?.MessageID : messageID,
          sortBy: "MessageID DESC",
          pageNo: 1,
          rowCountPerPage: 10000,
        };
        dispatch(messagesAction?.getMessageConversationDetails(params));
        // } else {
        //   dispatch(messagesAction?.viewCompleteConversation(messageID));
        // }
      })
      .catch((err) => {
        showToastNotification("Failed to update status", "error");
      });
  };

  const handleApproveOrReject = (id, e, option, item) => {
    Popup({
      title: "Message",
      text: `Are you sure want to ${option === "approve" ? "Approve" : "Reject"
        }?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => handleApproveOrRejectconfirm(id, e, option, item),
    });
  };


  useEffect(() => {
    if (!messageConversationDetails?.DataList?.[messageIndex - 1]) return;
    const newData = [
      {
        FacilityReview:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.FacilityReview,
        MessageReviewCommand:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageReviewCommand,
        MessageSubject:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageSubject,
        MessageFrom:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageFrom,
        MessageTo:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageTo,
        MessageCost:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageCost,
        MessageReviewCommandBy:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageReviewCommandBy,
        MessageBody:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageBody,
        MessageSentDate:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageSentDate,
        FacilityReviewStatus:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.FacilityReviewStatus,
        isVerifyCheckbox:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.isVerifyCheckbox ||
          messageConversationDetails?.DataList?.[
            messageIndex - 1
          ]?.MessageReviewCommand?.trim()?.length > 0 ||
          messageConversationDetails?.DataList?.[
            messageIndex - 1
          ]?.MessageReviewCommandBy?.trim()?.length > 0,
        MessageFlag:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageFlag,
        IsMsgApprove:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.IsMsgApprove,
        IsSenderMsgDelete:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.IsSenderMsgDelete,
        MessageStatus:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageStatus,
        MessageQuarantineKeyWords:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageQuarantineKeyWords,
        MessageBothFlagKeyWords:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageBothFlagKeyWords,
        KeyWordFilterType:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.KeyWordFilterType,
        MessageFlagKeyWords:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.MessageFlagKeyWords,
        Sender:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.Sender,
        RowIndexOfMessage:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.RowIndexOfMessage,
        MessageID:
          messageConversationDetails?.DataList?.[messageIndex - 1]?.MessageID,
        IsReceiverMsgDelete:
          messageConversationDetails?.DataList?.[messageIndex - 1]
            ?.IsReceiverMsgDelete,
        InmateID: messageConversationDetails?.DataList?.[messageIndex - 1]?.InmateID,
      },
    ];
    setCommand([
      messageConversationDetails?.DataList?.[messageIndex - 1]
        ?.MessageReviewCommand,
    ]);
    setData(newData);
  }, [messageIndex, messageConversationDetails]);

  const handlePrevNext = (direction) => {
    const totalCount = msgDataList?.TotalRecordCount || 0;
    const currentPage = messageSearchDetails?.PageNo || 1;
    const rowCountPerPage = messageSearchDetails?.RowCountPerPage || 10;

    // Total pages
    const totalPages = Math.ceil(totalCount / rowCountPerPage);
    const isprev = msgDataList?.DataList?.[0]?.MessageID == messageID;
    if (direction === "prev" && isprev) {
      if (currentPage <= totalPages) {
        if (source == "InmateMessage") {
          dispatch(inmateAction.setinitialMessageSearch({ ...messageSearchDetails, PageNo: currentPage == 1 ? currentPage : currentPage - 1 }));
        }
        else if (source === "publicUserMessage") {
          dispatch(publicUserActions?.setpuInitialMessageSearch({ ...messageSearchDetails, PageNo: currentPage == 1 ? currentPage : currentPage - 1 }));
        }
        else {
          dispatch(messagesAction?.setMessageSearchData({ ...messageSearchDetails, PageNo: currentPage == 1 ? currentPage : currentPage - 1 }));
        }
        handleBack();
      }
      return;
    }
    if (
      direction === "next" &&
      msgDataList?.DataList?.length === indexValue + 1
    ) {
      if (currentPage <= totalPages) {
        if (source == "InmateMessage") {
          dispatch(inmateAction.setinitialMessageSearch({ ...messageSearchDetails, PageNo: currentPage == totalPages ? currentPage : currentPage + 1 }));
        }
        else if (source === "publicUserMessage") {
          dispatch(publicUserActions?.setpuInitialMessageSearch({ ...messageSearchDetails, PageNo: currentPage == totalPages ? currentPage : currentPage + 1 }));
        }
        else {
          dispatch(messagesAction?.setMessageSearchData({ ...messageSearchDetails, PageNo: currentPage == totalPages ? currentPage : currentPage + 1 }));
        }
        handleBack();
      }
      return;
    }
    setIndexValue((prev) => (direction === "next" ? prev + 1 : prev - 1));

  };

  const handleCompleteConversation = async () => {
    setCommand([]);
    isNotesRef.current = false;
    setselectLang("");
    setShowCompleteConvo(true);
    const messagegridData = viewCompleteConversation;
    // dispatch(messagesAction?.viewCompleteConversation(messagegridData?.length > 0 ? messagegridData[0]?.MessageID : messageID))

    const params = {
      messageID: messagegridData?.length > 0 ? messagegridData[0]?.MessageID : messageID,
      sortBy: "MessageID DESC",
      pageNo: 1,
      rowCountPerPage: 10000,
    };
    //  dispatch(messagesAction?.getMessageConversationDetails(params))
    //   .then((result) => {
    // const result = messageConversationDetails?.DataList;
    //  setViewCompleteConversation(result);
    const content = [];
    const subject = [];
    setUpdateMessageContent(content);
    setUpdateSubjectContent(subject);
    const convoList = messagegridData || [];
    const commandTxt = [...command];
    convoList?.map((list, i) => {
      const quarantineKeywords =
        list?.MessageQuarantineKeyWords?.split("|").map((word) =>
          word.toLowerCase()
        ) || [];
      const regex = new RegExp(
        `\\b(${quarantineKeywords.join("|")})\\b`,
        "gi"
      );
      const highlightedMessageContent = list?.MessageBody?.replace(
        regex,
        (match) => {
          return `<span style="color: red; font-weight: bold;">${match}</span>`;
        }
      );
      content?.push(highlightedMessageContent);
      setUpdateMessageContent(content);
      const highlightedSubject = list?.MessageSubject?.replace(regex, (match) => {
        return `<span style="color: red; font-weight: bold;">${match}</span>`;
      });
      subject?.push(highlightedSubject);
      setUpdateSubjectContent(subject);
      // });
      const MessageReviewCommand = list?.MessageReviewCommand || "";
      commandTxt[i] = MessageReviewCommand;
      setCommand(commandTxt);
    });
    // })
    // .catch((err) => {
    //   showToastNotification(
    //     "Failed to get complete conversation details",
    //     "error"
    //   );
    // });
  };

  const handleBack = () => {
    setCommand([]);
    isNotesRef.current = false;
    setselectLang("");
    setisloading(true);
    setTimeout(() => {
      if (showCompleteConvo) {
        const tableData = [...messageConversationDetails?.DataList];
        const updateArr = tableData?.map((item, index) => {
          if (item?.MessageID === data[0]?.MessageID) {
            const returnvalue = {
              ...item,
              isVerifyCheckbox:
                item?.MessageReviewCommand?.trim()?.length > 0 ? true : false,
            };
            setData([returnvalue]);
            return returnvalue;
          }
          return item;
        });
        setShowCompleteConvo(false);
      } else if (source && source === "publicUserMessage") {
        history.navigate("PublicUserList/Details", {
          state: { row: row },
        });
        dispatch(publicUserActions?.setPublicUserTab("publicuser-message-tab"));
      } else if (source && source === "InmateMessage") {
        dispatch(inmateAction.setInmateCurrentTab("inmate-message-tab"));
        history.navigate("InmateList/Details", {
          state: { inmate: Inmate, showTransactionTab: false },
        });
      } else {
        //
        history?.navigate("MessageList");
      }
      setisloading(false);
    }, 100);
  };

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
        size: A4 portrait;
        margin: 20mm 15mm 20mm 15mm !important;
      }
  
      html, body {
        margin: 0 !important;
        padding: 0 !important;
         height: auto !important;
         overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
  
      .print-title {
        text-align: center !important;
        font-size: 24px !important;
        font-weight: bold !important;
        margin: 10px 0 !important;
        color: black !important;
      }
  
      table {
        width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
        margin-bottom: 15px !important;
      }
  
      tr, td, th {
        border: 2px solid black !important;
        padding: 8px !important;
        vertical-align: top !important;
      }
  
      * {
        color: black !important;
        font-size: 16px !important;
      }
    }`,

    content: () => {
      const printContainer = document.createElement("div");
      printContainer.className = "print-container";

      const titleElement = document.createElement("h1");
      titleElement.className = "print-title";
      titleElement.style.marginTop = "10px";
      titleElement.textContent = "Message Conversation";
      printContainer.appendChild(titleElement);

      messageitem?.forEach((obj, index) => {
        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.borderCollapse = "collapse";
        table.style.marginBottom = "15px";

        // const rawSubject = updateSubjectContent[index] || obj["MessageSubject"];
        const rawSubject = obj["MessageSubject"] || updateSubjectContent[index];
        const updatedSubject = rawSubject
          .replace(/color:\s*red;/gi, "color: black;")
          .replace(/font-weight:\s*bold;/gi, "font-weight: normal;");
        // const updatedBody = updateMessageContent[index] || obj["MessageBody"];
        const updatedBody = obj["MessageBody"] || updateMessageContent[index];

        const rows = [
          { label: "From", value: obj["MessageFrom"] || "N/A" },
          { label: "To", value: obj["MessageTo"] || "N/A" },
          { label: "Subject", value: updatedSubject },
          { label: "Body", value: updatedBody },
          { label: "Date", value: obj["MessageSentDate"] || "N/A" },
          { label: "Status", value: obj["MessageStatus"] || "N/A" },
        ];

        rows.forEach((row) => {
          const tr = document.createElement("tr");

          const th = document.createElement("th");
          th.textContent = row.label;
          th.style.border = "2px solid black";
          th.style.padding = "8px";
          th.style.textAlign = "left";
          th.style.width = "30%";
          tr.appendChild(th);

          const td = document.createElement("td");
          td.style.border = "2px solid black";
          td.style.padding = "8px";
          td.style.width = "70%";
          td.style.wordBreak = "break-word";
          td.style.whiteSpace = "pre-wrap";

          // Render Subject/Body with HTML formatting
          if (row.label === "Subject" || row.label === "Body") {
            const content = row.value.replace(/\n/g, "<br />");
            td.innerHTML = content;
          } else {
            td.textContent = row.value;
          }

          tr.appendChild(td);
          table.appendChild(tr);
        });

        printContainer.appendChild(table);
      });

      const printWrapper = document.createElement("div");
      printWrapper.style.display = "none";
      printWrapper.appendChild(printContainer);
      document.body.appendChild(printWrapper);

      return printContainer;
    },

    onBeforeGetContent: () => {
      // Optional before print logic
    },

    onAfterPrint: () => {
      // Optional cleanup
    },
  });

  const handleClickPDF = () => {
    let title = "Message Conversation";
    let pdfdata = viewCompleteConversation?.map((obj) => ({
      From: obj.MessageFrom || "N/A",
      To: obj.MessageTo || "N/A",
      Subject: obj.MessageSubject || "N/A",
      Body: obj.MessageBody || "N/A",
    }));
    try {
      generateMessageConversationPDF(title, pdfdata);
    } catch (error) {
      showToastNotification("Failed to expot PDF", "error");
    }
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }
  return (
    <>
      <div className="d-none" id="output"></div>
      <div className="d-none" id="outputBody"></div>
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space ">
          <h2 className=" text-color">MESSAGE CONVERSATION</h2>
          <div className="d-flex flex-wrap gap-3">
            {showCompleteConvo && (
              <>
                {/* <PDFExport
                handlePDFExport={handleClickPDF}
                className="btn btn-primary me-2" // Adds margin to the right of this button
              /> */}
                <PrintExport
                  handlePrintShow={() => {
                    handlePrints();
                  }}
                />
              </>
            )}
            <Button
              label="Back"
              type="button"
              className=" me-2"
              // onClick={() => history?.navigate("MessageList")}
              onClick={() => handleBack()}
              variant="danger"
              status={"primary"}
              icon={"fa-solid fa-angle-left"}
              disabled={false}
            />
          </div>
        </div>

        <div>
          <div className="py-3 d-flex flex-wrap mobile-left  align-items-center gap-3">
            {!showCompleteConvo && (
              <Button
                label="View Complete Conversation"
                status="btn-label"
                type="button"
                className={"w-max"}
                icon={"fa-solid fa-comments"}
                onClick={() => handleCompleteConversation()}
              />
            )}
            <Button
              label={isTranslating ? "Translating..." : "Traducir al español"}
              status="btn-label"
              type="button"
              className={"w-max"}
              icon={"language"}
              onClick={() => handleTranslate("es")}
            />

            <Button
              label="Translate to English"
              status="btn-label"
              type="button"
              className={"w-max"}
              icon={"globe"}
              onClick={() => handleTranslate("en")}
            />

            <Button
              variant="secondary"
              className="me-2"
              label={"RESET"}
              type={"button"}
              status="btn-label"
              disabled={false}
              icon={"fa-solid fa-rotate-right"}
              onClick={() => {
                handleReset();
              }}
            />
          </div>

          <div className="mt-3" ref={componentRef}>
            <MessageViewer
              showCompleteConvo={showCompleteConvo}
              handleNotesChange={handleNotesChange}
              handleVerifyNotes={handleVerifyNotes}
              data={
                !showCompleteConvo ? data : viewCompleteConversation
              }
              totalRowCount={totalRowCount || messageConversationDetails?.TotalRecordCount}
              handleReviewNotes={handleReviewNotes}
              handleApproveOrReject={handleApproveOrReject}
              handlePrevNext={handlePrevNext}
              indexValue={indexValue}
              messagesList={msgDataList}
              updateSubjectContent={updateSubjectContent}
              updateMessageContent={updateMessageContent}
              command={command}
              messageIndex={messageIndex}
              setmessageIndex={setmessageIndex}
              selectLang={selectLang}
              isNotesRef={isNotesRef}
              messageitem={messageitem}
              setmessageitem={setmessageitem}
              isprevdisabled={isprevdisabled}
              isnextdisabled={isNextDisabled}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(PhotoInformation);
